import {object, string} from "yup";

export default object({
  company_name: string().required(),
  login: string().required(),
  password: string().required(),
})
